import { useCallback, useRef, useState } from "react";

/** alert() орнына — экранның төменгі оң жағындағы қысқа хабарламалар. */
export function useToasts() {
  const [toasts, setToasts] = useState([]);
  const seq = useRef(0);

  const dismiss = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const push = useCallback(
    (text, type = "success") => {
      const id = ++seq.current;
      setToasts((prev) => [...prev.slice(-3), { id, text, type }]);
      setTimeout(() => dismiss(id), type === "error" ? 7000 : 3500);
    },
    [dismiss]
  );

  return { toasts, push, dismiss };
}

export function ToastStack({ toasts, onDismiss }) {
  if (!toasts.length) return null;
  return (
    <div className="pointer-events-none fixed bottom-6 right-6 z-[120] flex w-80 flex-col gap-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          role="status"
          className={`pointer-events-auto flex items-start gap-2 rounded-lg border px-4 py-3 text-sm shadow-lg ${
            t.type === "error"
              ? "border-rose-500/50 bg-rose-600 text-white"
              : "border-emerald-500/50 bg-emerald-600 text-white"
          }`}
        >
          <span className="flex-1 whitespace-pre-line">{t.text}</span>
          <button
            type="button"
            onClick={() => onDismiss(t.id)}
            className="text-white/80 hover:text-white"
            aria-label="Закрыть"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
